export default "__VITE_ASSET__Bd7hETbE__"